var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "form-group m-form__group row" }, [
      _c(
        "div",
        { class: [{ "has-danger": _vm.errors.has("companies") }, "col-lg-3"] },
        [
          _c("label", { attrs: { for: "companies" } }, [
            _vm._v(
              _vm._s(_vm._f("capitalize")(_vm._f("translate")("companies")))
            )
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.company_ids,
                  expression: "company_ids"
                }
              ],
              staticClass: "form-control m-bootstrap-select m_selectpicker",
              attrs: {
                id: "companies",
                name: "companies",
                multiple: "",
                title: _vm._f("translate")("select_an_option")
              },
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.company_ids = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.selectAllCompanies
                ]
              }
            },
            [
              _c("option", { attrs: { value: "all" } }, [
                _vm._v(_vm._s(_vm._f("capitalize")("all")))
              ]),
              _vm._v(" "),
              _vm._l(_vm.companies, function(company, key) {
                return _c(
                  "option",
                  { key: key, domProps: { value: company.id } },
                  [_vm._v("\n          " + _vm._s(company.name) + "\n        ")]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("companies"),
                  expression: "errors.has('companies')"
                }
              ],
              staticClass: "m-form__help m--font-danger"
            },
            [_vm._v(" " + _vm._s(_vm.errors.first("companies")) + " ")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: [{ "has-danger": _vm.errors.has("auth_types") }, "col-lg-3"] },
        [
          _c("label", { attrs: { for: "auth_types" } }, [
            _vm._v(
              _vm._s(
                _vm._f("capitalize")(_vm._f("translate")("authorized_type"))
              )
            )
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.auth_types_ids,
                  expression: "auth_types_ids"
                }
              ],
              staticClass: "form-control m-bootstrap-select m_selectpicker",
              attrs: {
                id: "auth_types",
                name: "auth_types",
                multiple: "",
                title: _vm._f("translate")("select_an_option")
              },
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.auth_types_ids = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.selectAllAuthTypes
                ]
              }
            },
            [
              _c("option", { attrs: { value: "all" } }, [
                _vm._v(_vm._s(_vm._f("capitalize")("all")))
              ]),
              _vm._v(" "),
              _vm._l(_vm.auth_types, function(auth_type, key) {
                return _c(
                  "option",
                  { key: key, domProps: { value: auth_type.id } },
                  [
                    _vm._v(
                      "\n          " + _vm._s(auth_type.name) + "\n        "
                    )
                  ]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("auth_type"),
                  expression: "errors.has('auth_type')"
                }
              ],
              staticClass: "m-form__help m--font-danger"
            },
            [_vm._v(" " + _vm._s(_vm.errors.first("auth_type")) + " ")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [{ "has-danger": _vm.errors.has("person_type") }, "col-lg-3"]
        },
        [
          _c("label", { attrs: { for: "person_type" } }, [
            _vm._v(
              _vm._s(_vm._f("capitalize")(_vm._f("translate")("person_type")))
            )
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.person_type,
                  expression: "person_type"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              class: {
                "form-control": true,
                error: _vm.errors.has("person_type")
              },
              attrs: { name: "person_type", id: "person_type" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.person_type = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c("option", { attrs: { value: "" } }, [
                _vm._v(_vm._s(_vm._f("capitalize")("select_an_option")))
              ]),
              _vm._v(" "),
              _vm._l(
                _vm.report_type === 2 ? _vm.person_types : _vm.person_types_by,
                function(person_type, key) {
                  return _c(
                    "option",
                    { key: key, domProps: { value: person_type.value } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")(person_type.name)
                          )
                        )
                      )
                    ]
                  )
                }
              )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("person_type"),
                  expression: "errors.has('person_type')"
                }
              ],
              staticClass: "m-form__help m--font-danger"
            },
            [_vm._v(" " + _vm._s(_vm.errors.first("person_type")) + " ")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [{ "has-danger": _vm.errors.has("autho_state") }, "col-lg-3"]
        },
        [
          _c("label", { attrs: { for: "autho_state" } }, [
            _vm._v(_vm._s(_vm._f("capitalize")(_vm._f("translate")("state"))))
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: _vm.report_type === 2 ? "required" : "",
                  expression: "report_type === 2 ? 'required' : ''"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.autho_state,
                  expression: "autho_state"
                }
              ],
              staticClass: "form-control m-bootstrap-select m_selectpicker",
              attrs: {
                id: "autho_state",
                name: "autho_state",
                multiple: "",
                title: _vm._f("translate")("select_an_option")
              },
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.autho_state = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.selectAllAuthoStates
                ]
              }
            },
            [
              _c("option", { attrs: { value: "all" } }, [
                _vm._v(_vm._s(_vm._f("capitalize")("all")))
              ]),
              _vm._v(" "),
              _vm._l(_vm.autho_states, function(autho_state, key) {
                return _c(
                  "option",
                  { key: key, domProps: { value: autho_state.id } },
                  [
                    _vm._v(
                      "\n          " + _vm._s(autho_state.title) + "\n        "
                    )
                  ]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("autho_state"),
                  expression: "errors.has('autho_state')"
                }
              ],
              staticClass: "m-form__help m--font-danger"
            },
            [_vm._v(" " + _vm._s(_vm.errors.first("autho_state")) + " ")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: [{ "has-danger": _vm.errors.has("start_date") }, "col-lg-3"] },
        [
          _c("label", { attrs: { for: "start_date" } }, [
            _vm._v(
              _vm._s(_vm._f("capitalize")(_vm._f("translate")("start_date")))
            )
          ]),
          _vm._v(" "),
          _c("s-date-time-picker", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value:
                  _vm.report_type === 11 || _vm.report_type === 12
                    ? ""
                    : "required|validateDate",
                expression:
                  "report_type === 11  || report_type === 12 ? '' : 'required|validateDate'"
              }
            ],
            attrs: {
              id: "start_date",
              name: "start_date",
              options: _vm.config.start,
              placeholder: "AAAA-MM-DD"
            },
            on: {
              empty: function($event) {
                _vm.start_date = $event
              }
            },
            model: {
              value: _vm.start_date,
              callback: function($$v) {
                _vm.start_date = $$v
              },
              expression: "start_date"
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("start_date"),
                  expression: "errors.has('start_date')"
                }
              ],
              staticClass: "m-form__help m--font-danger"
            },
            [_vm._v(" " + _vm._s(_vm.errors.first("start_date")) + " ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: [{ "has-danger": _vm.errors.has("end_date") }, "col-lg-3"] },
        [
          _c("label", { attrs: { for: "end_date" } }, [
            _vm._v(
              _vm._s(_vm._f("capitalize")(_vm._f("translate")("end_date")))
            )
          ]),
          _vm._v(" "),
          _c("s-date-time-picker", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value:
                  _vm.report_type === 11 || _vm.report_type === 12
                    ? ""
                    : "required|validateDate",
                expression:
                  "report_type === 11  || report_type === 12 ? '' : 'required|validateDate'"
              }
            ],
            attrs: {
              id: "end_date",
              name: "end_date",
              options: _vm.config.end,
              placeholder: "AAAA-MM-DD"
            },
            on: {
              empty: function($event) {
                _vm.end_date = $event
              }
            },
            model: {
              value: _vm.end_date,
              callback: function($$v) {
                _vm.end_date = $$v
              },
              expression: "end_date"
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("end_date"),
                  expression: "errors.has('end_date')"
                }
              ],
              staticClass: "m-form__help m--font-danger"
            },
            [_vm._v(" " + _vm._s(_vm.errors.first("end_date")) + " ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            { "has-danger": _vm.errors.has("show_blockade") },
            "col-lg-3"
          ],
          staticStyle: { padding: "10px", "padding-top": "45px" }
        },
        [
          _c("label", { attrs: { for: "show_blockade" } }, [
            _vm._v(
              _vm._s(_vm._f("capitalize")(_vm._f("translate")("show_blockade")))
            )
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.show_blockade,
                expression: "show_blockade"
              }
            ],
            attrs: {
              type: "checkbox",
              name: "show_blockade",
              id: "show_blockade"
            },
            domProps: {
              checked: Array.isArray(_vm.show_blockade)
                ? _vm._i(_vm.show_blockade, null) > -1
                : _vm.show_blockade
            },
            on: {
              change: function($event) {
                var $$a = _vm.show_blockade,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.show_blockade = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.show_blockade = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.show_blockade = $$c
                }
              }
            }
          })
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group m-form__group row" }, [
      _c(
        "div",
        { staticClass: "col-lg-12", staticStyle: { "text-align": "right" } },
        [
          _c("label", { attrs: { for: "" } }, [_vm._v(" ")]),
          _c("br"),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-success m-btn m-btn--icon",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.generateReport()
                }
              }
            },
            [
              _c("span", [
                _c("i", { staticClass: "la la-archive" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm._f("capitalize")(
                        _vm._f("translate")("generate_report")
                      )
                    )
                  )
                ])
              ])
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9e202f92", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e202f92","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/reports/forms/AuthorizedPersonalForm.vue
// module id = 505
// module chunks = 0 1 4 46